import { createFileRoute } from '@tanstack/react-router'
import './legal.css'

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicy,
})

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Privacy Policy</h1>
        
        <p className="legal-intro">
          This privacy policy applies to all users accessing the Platform and is crucial for understanding the handling of personal and store information. The policy governs the use of the applications, namely 'Modulus Buy,' 'Modulus Sell,' and associated products, websites, and services managed by Modulus Seventeen (OPC) Private Limited. By submitting personal or store information, users consent to its use and processing as outlined in this policy.
        </p>

        <section className="legal-section">
          <h2>Information Collection and Usage</h2>
          <p>
            We collect information when you access and register on the Application or Website. This includes personal details such as name, age, email address, location, phone number, password, and your store details. Transaction-related information is also obtained, such as purchases, sales, responses to offers, and downloads or usage of applications. This information is categorized as "Personal Information," "Sensitive Personal Information," and "Associated Information" per the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.
          </p>
          <p>
            We use this information to contact you, provide services, important information, notifications, and marketing promotions. The data helps us improve services, personalize your experience, and communicate regarding your account and our services. It is also used for marketing, fraud prevention, and responding to inquiries.
          </p>
        </section>

        <section className="legal-section">
          <h2>Cookies</h2>
          <p>
            Cookies are employed to track preferences, enhance user experience, and analyze user trends. While most browsers accept cookies by default, users can modify settings to refuse them. Disabling cookies may affect the functionality of certain features and services.
          </p>
        </section>

        <section className="legal-section">
          <h2>Sharing and Disclosure</h2>
          <p>
            Service Providers may be engaged to perform services, and they may have access to personal information only for the purpose of providing these services. Personal information may be disclosed to comply with legal requirements, enforce terms of use, protect rights or safety, investigate fraud, or respond to government requests.
          </p>
        </section>

        <section className="legal-section">
          <h2>Information Security</h2>
          <p>
            We prioritize the confidentiality of your information and implement physical, electronic, and procedural safeguards. Your information is stored and processed securely, and we do not sell, transfer, or rent it to third parties for marketing purposes without explicit consent.
          </p>
        </section>

        <section className="legal-section">
          <h2>No Refund Policy</h2>
          <p>
            All transactions made through the Platform are final. We do not offer refunds for any purchases, subscriptions, or services once the transaction is completed. Users are advised to carefully review all details before completing any transaction. In case of any disputes or concerns regarding transactions, please contact our support team.
          </p>
        </section>

        <section className="legal-section">
          <h2>Public Forums</h2>
          <p>
            Certain features like discussion forums may expose personal information to the public. Users should be cautious about sharing personal information in such forums.
          </p>
        </section>

        <section className="legal-section">
          <h2>User Customization</h2>
          <p>
            Users have the option to customize how their personal information is used for communication and marketing. Opt-out options are provided for promotional communications.
          </p>
        </section>

        <section className="legal-section">
          <h2>Ownership of Rights</h2>
          <p>
            All rights, including copyright, in the Website/Application are owned by or licensed to us. Any use of the content for commercial or public purposes without permission is prohibited.
          </p>
        </section>

        <section className="legal-section">
          <h2>Consent</h2>
          <p>
            By registering, users explicitly consent to the collection, processing, storage, disclosure, and handling of their information as described in this policy.
          </p>
        </section>

        <section className="legal-section">
          <h2>Updates to Policy</h2>
          <p>
            The privacy policy evolves to cover new situations. Users are advised to regularly review the policy for any changes, and continued use signifies approval of changes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>For questions about this Privacy Policy, contact us at:</p>
          <p>
            Website: <a href="https://www.modulusseventeen.com/">https://www.modulusseventeen.com/</a><br />
            Email: <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a>
          </p>
        </section>
      </div>
    </div>
  )
}
